import React, { FC } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    makeStyles,
    createStyles,
    IconButton,
    TableContainer
} from '@material-ui/core'

import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons'
import { DispatchStateDto } from './entities/DispatchStateDto'
import { Pagination, PaginationProps } from '../../components/Pagination'

interface Props extends PaginationProps {
    data?: DispatchStateDto[]
    onEdit?: (id: number) => void
    onDelete?: (id: number) => void
}

export const DispatchStateTable: FC<Props> = ({
    data = [],
    onEdit,
    pagination,
    onPaginationChange,
    onDelete
}) => {
    const styles = useStyles()

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='center'>Código</TableCell>
                        <TableCell align='center'>Nombre</TableCell>
                        <TableCell align='center'>Tipo de Estado</TableCell>
                        <TableCell align='center'>Estado Actual</TableCell>
                        <TableCell align='center'>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data.map(item => {
                            return (
                                <TableRow key={item.dispatchStateId}>
                                    <TableCell align='center'>{item.dispatchStateId}</TableCell>
                                    <TableCell align='center'>{item.stateName}</TableCell>
                                    <TableCell align='center'>{item.dispatchStateType.stateName}</TableCell>
                                    <TableCell align='center'>{item.active ? 'Activo' : 'Inactivo'}</TableCell>
                                    <TableCell align='center'>
                                        <div className={styles.action}>
                                            <IconButton onClick={() => onEdit && onEdit(item.dispatchStateId)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton  aria-label='delete' onClick={() => onDelete && onDelete(item.dispatchStateId)}>                                                    
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
            <Pagination pagination={pagination} onPaginationChange={onPaginationChange}/>
        </TableContainer>
    )
}

const useStyles = makeStyles(
    createStyles({
        action: {
            display: 'inline-block',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
        }
    })
)

